import { getSpeakersList } from 'api/voices.js'
import {getDubPrice} from 'api/pricing'
import store from '@/store'

export async function getSpeakersMap () {
  let speakersMap = store.state.global.speakerMap
  if (Object.keys(speakersMap).length===0 ) {
    speakersMap = {}
    const res = await getSpeakersList()
    const {list} = res.data
    list && list.forEach((ele) => {
      speakersMap[ele.id] = ele
    })
    store.dispatch('global/setSpeakerMap', speakersMap)
  }
  return speakersMap
}

export async function getStateDubPrice () {
  let dubPrice = store.state.global.dubPrice
  if (dubPrice.length === 0) {
    const res = await getDubPrice()
    dubPrice = res.data.dubbing_product_list
    store.dispatch('global/setDubPrice', dubPrice)
  }
  return dubPrice
}
